import { ui } from "@/components/ui";
import useNavigateToDiary from '../hooks/useNavigateToDiary';

const GoToDiariesCard = () => {

	const {navigateToDiary,diaryWord} = useNavigateToDiary();
	return (
		<ui.Card className="bg-indigo-100 mb-4 border-indigo-300">
			<ui.CardHeader>
				<ui.CardTitle>Go to {diaryWord}</ui.CardTitle>
				<ui.CardDescription className="text-md">
					Diaries serve as your personal health logs, allowing your
					care team to make better decisions.
				</ui.CardDescription>
			</ui.CardHeader>
			<ui.CardFooter>
					<ui.Button onClick={navigateToDiary} size="md" asChild={false}>
						Go to {diaryWord}
					</ui.Button>
			</ui.CardFooter>
		</ui.Card>
	);
};

export default GoToDiariesCard;
